declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData, AutoGenCsvList } from '../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-csvlistpv',
    templateUrl: './autogencsvlistpv.component.html',
    styleUrls: ['./autogencsvlistpv.component.scss']
})

export class AutoGenCsvListPVComponent implements OnInit {
    @Input()
    public FormMode: string = 'Edit';
    @Input() public field: FieldData;

    @Input() public Data: AutoGenCsvList;

    ngOnInit(): void {
        //this.Data = new AutoGenCsvList();
        //this.Data.ValueSourceName = this.field.ValueSource;
        this.Data.parse();
    }
    @Input() SelectedValue: string = "";

}
